import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorsServices } from '../../new-contract-pymes-multipoint.model';

@Component({
  selector: 'app-multipoint-modal-error-endpoints',
  templateUrl: './multipoint-modal-error-endpoints.component.html',
  styleUrls: ['./multipoint-modal-error-endpoints.component.scss']
})
export class MultipointModalErrorEndpointsComponent {

  constructor(
    private dialogRef: MatDialogRef<MultipointModalErrorEndpointsComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: ErrorsServices
  ) { }

  public closeModal(): void {
    this.dialogRef.close();
  }

}
